class PdpBundlePicker extends HTMLElement {
  connectedCallback() {
    this._cards = Array.from(this.querySelectorAll(".pdp-bundle-picker__card-wrap"));
    this._mobileCta = this.querySelector(".pdp-bundle-picker__mobile-cta");
    this._mobileCtaLabel = this.querySelector(".pdp-bundle-picker__mobile-cta-label");
    this._mobileCtaPrice = this.querySelector(".pdp-bundle-picker__mobile-cta-price");
    this._mobileCtaCompareSel = this.querySelector(".pdp-bundle-picker__mobile-cta-compare s");
    if (!this._cards.length) return;
    this._selected = null;
    this._busy = false;
    this._cards.forEach((card) => {
      card.addEventListener("click", (e) => {
        const cta = e.target.closest(".pdp-bundle-picker__card-cta");
        if (cta) {
          e.preventDefault();
          this._checkout(card);
          return;
        }
        this._selectCard(card);
      });
      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this._selectCard(card);
        }
      });
    });
    if (this._mobileCta) {
      this._mobileCta.addEventListener("click", (e) => {
        e.preventDefault();
        if (this._selected) this._checkout(this._selected);
      });
    }
    const defaultCard = this._cards.find((c) => c.hasAttribute("data-featured")) ?? this._cards[0];
    this._selectCard(defaultCard);
  }

  _selectCard(selected) {
    this._selected = selected;
    this._cards.forEach((card) => {
      card.classList.remove("is-selected");
      card.setAttribute("aria-checked", "false");
    });
    selected.classList.add("is-selected");
    selected.setAttribute("aria-checked", "true");
    if (this._mobileCta) this._updateMobileCta(selected);
  }

  _updateMobileCta(card) {
    const { salePrice = "", comparePrice = "", ctaText = "Add to Cart" } = card.dataset;
    this._mobileCta.href = "#";
    this._mobileCta.setAttribute("aria-label", `${ctaText} \u2014 ${salePrice}`);
    if (this._mobileCtaLabel) this._mobileCtaLabel.textContent = ctaText;
    if (this._mobileCtaPrice) this._mobileCtaPrice.textContent = salePrice;
    if (this._mobileCtaCompareSel) this._mobileCtaCompareSel.textContent = comparePrice;
  }

  _checkout(card) {
    if (this._busy) return;
    const variantId = card.dataset.variantId;
    const sellingPlan = card.dataset.sellingPlan;
    if (!variantId) return;
    this._busy = true;
    const item = { id: Number(variantId), quantity: 1 };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [item] }),
    })
      .then((r) => {
        if (!r.ok) throw new Error("add failed");
        window.location.href = "/checkout";
      })
      .catch(() => {
        this._busy = false;
        window.location.href = card.dataset.checkoutUrl || "/cart";
      });
  }
}
customElements.define("pdp-bundle-picker", PdpBundlePicker);
